import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { MailingApi } from 'API/mailing'
import { IMailing, Status } from 'interfaces'

const initialState: {
	list: IMailing[]
	status: Status
} = {
	list: [],
	status: 'init',
}

export const getMailings = createAsyncThunk('Mailing/getMailings', async () => {
	const mailings = await MailingApi.getAll()
	return {
		mailings,
	}
})
export const getMailing = createAsyncThunk('Mailing/getMailing', async (id: number) => {
	return await MailingApi.getOne(id)
})

const MailingSlice = createSlice({
	name: 'Mailing',
	initialState,
	reducers: {
		deleteItem(state, { payload }: PayloadAction<number>) {
			if (state.list) {
				const index = state.list.findIndex((f) => f.id === payload)
				if (index >= 0) {
					state.list.splice(index, 1)
				}
			}
		},
	},
	extraReducers: (builder) => {
		builder.addCase(getMailings.pending, (state) => {
			state.status = 'pending'
		})
		builder.addCase(getMailings.rejected, (state) => {
			state.status = 'rejected'
		})
		builder.addCase(getMailings.fulfilled, (state, { payload }) => {
			if (payload) {
				state.list = payload.mailings
			}
			state.status = 'fulfilled'
		})
		builder.addCase(getMailing.fulfilled, (state, { payload }) => {
			if (!payload) return
			const index = state.list.findIndex((f) => f.id === payload.id)
			if (index >= 0) {
				state.list.splice(index, 1, payload)
			} else {
				state.list.push(payload)
			}
		})
	},
})

export const MailingAction = MailingSlice.actions

export const MailingReducer = MailingSlice.reducer
